const Modulo = (modulo) => {
  try {
    let ruta = modulo.href;

    return (
      <div
        className="w-full min-w-[390px] md:w-1/2 lg:w-1/4 p-4"
        key={modulo.id}
      >
        <a href={`${ruta}`}>
          <div
            style={{
              flexDirection: "row",
              display: "flex",
              width: "100%",
              background: `${modulo.color}`,
              height: 100,
              borderRadius: 10,
              //minWidth: "fit-content",
              //minHeight: "fit-content",
            }}
          >
            <div
              style={{
                width: "20%",
                justifyContent: "center",
                display: "flex",
              }}
              className="px-2 min-w-[64px] mx-2"
            >
              {modulo.iconHero === false || modulo.iconHero === undefined ? (
                <img
                  style={{ objectFit: "contain" }}
                  src={modulo.icono}
                  width="64"
                  height="64"
                  alt=""
                  className="min-w-[64px] min-h-[64px]"
                />
              ) : (
                <>{modulo.icono}</>
              )}
            </div>
            <div
              style={{
                flexDirection: "column",
                display: "flex",
                marginLeft: 5,
                width: "80%",
                //borderLeft: "1px white solid",
              }}
            >
              <div className="my-auto px-5">
                <div>
                  <label
                    style={{
                      fontWeight: "bold",
                    }}
                    className="text-gray-600"
                  >
                    {modulo.titulo}
                  </label>
                </div>
                <div>
                  <label style={{ fontSize: "14px" }} className="text-gray-600">
                    {modulo.descripcion}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </a>
      </div>
    );
  } catch (err) {
    console.log("Modulo err");
    console.log(err);
    return (
      <div>
        <label>{JSON.stringify(err)}</label>
      </div>
    );
  }
};

export default Modulo;
